import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I tried weed for performance enhancement and here's what I found",
  "description": "",
  "published": "2018-06-28T00:00:00.000Z",
  "redirect_from": ["/blog/tried-weed-performance-enhancement/swizec/8487"],
  "categories": "Personal, Thoughts",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This is not your high school weed experience anymore, my friend. Wow 😱`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/06/Image-from-iOS-1024x768.jpg",
        "alt": null
      }}></img></p>
    <p>{`Here's what weed looked like in high school:`}</p>
    <ol>
      <li parentName="ol">{`You have that one classmate who knows how and where to get "large" amounts of weed; he's everyone's dealer.`}</li>
      <li parentName="ol">{`You and a couple of buddies scrounge together some money, like ten or twenty bucks.`}</li>
      <li parentName="ol">{`You tell that one classmate that you would like to purchase an entire gram of weed. Two grams if you're feeling rich.`}</li>
      <li parentName="ol">{`A few days later, before school, or after school, or at recess, you exchange your $10 for 1g of green stuff.`}</li>
      <li parentName="ol">{`You carefully inspect the green stuff for any traces of sand or other shit that makes it heavier than it needs to be. Make sure there's no twigs that would break your papers. Yes, people cut weed.`}</li>
      <li parentName="ol">{`You buy a bunch of rolling tobacco and some papers.`}</li>
      <li parentName="ol">{`You fumble around and make a joint. Tobacco with a little bit of weed because that 1 gram has to last you 4 or 5 joints. You ain't made of money.`}</li>
      <li parentName="ol">{`You smoke and wheeze and cough and god knows what kind of shit you bought.`}</li>
      <li parentName="ol">{`Every time you wonder: `}<em parentName="li">{`"Is this the one time he sold me sprayed weed and I'm gonna have an insane crazy high?"`}</em></li>
      <li parentName="ol">{`You are stoned out of your mind. Knees heavy, arms spaghetti, you eat everything in sight, and you can't think straight to save your life.`}</li>
    </ol>
    <p>{`Stoner comedies are the best. Going back to school after… that was not a good idea the few times I tried.`}</p>
    <p>{`Don't smoke weed during recess. It doesn't work. Especially if you have a surprise English test you forgot about right after. Heh 😅`}</p>
    <h2 {...{
      "id": "the-modern-weed-experience-"
    }}>{`The modern weed experience 👌`}</h2>
    <p>{`Compare that to weed in 2018.`}</p>
    <ol>
      <li parentName="ol">{`It's legal, at least where I am.`}</li>
      <li parentName="ol">{`You open an app on your phone. I used `}<a parentName="li" {...{
          "href": "https://www.eaze.com/menu"
        }}>{`Eaze`}</a>{`.`}</li>
      <li parentName="ol">{`You send a photo of your passport so they can verify your age. Gotta be over 21`}</li>
      <li parentName="ol">{`There is a fine selection of different marijuana strains, different THC levels, CBD levels and every product comes with a helpful table that says `}<em parentName="li">{`"Yo, you gonna be hungry!"`}</em>{` or `}<em parentName="li">{`"This will help you focus"`}</em>{` and shows you the different tradeoffs behind every joint.`}</li>
      <li parentName="ol">{`You order and wait.`}</li>
      <li parentName="ol">{`An hour later, the most relaxed delivery person I have ever seen in my life shows up, checks your ID, and hands you a plain white bag.`}</li>
      <li parentName="ol">{`Inside is your order. Neatly packaged, nicely pre-rolled, well-labeled.`}</li>
      <li parentName="ol">{`No tobacco, no shit weed, no surprises. You know exactly what you're getting and the experience you're gonna have.`}</li>
    </ol>
    <p>{`I got a pair of Indica joints and a pair of Sativa. Indica is supposed to help you relax, loosen up your muscles, and go to bed. Sativa is meant to give you a little euphoria and a lot of focus.`}</p>
    <h2 {...{
      "id": "the-result"
    }}>{`The result`}</h2>
    <p>{`I finished about half a joint each time. Then I got bored sitting outside by myself.`}</p>
    <p>{`Weed just isn't as much fun on your own as it is when you're sneaking around with your best friend at a children's playground late at night and giggling like maniacs every time you think a passerby spotted you.`}</p>
    <p>{`Plus my spidey senses were saying I'd had enough. You can't really tell how high you are until you stand up. Funny, that.`}</p>
    <p>{`So, the first night I tried an indica strain.`}</p>
    <p>{`The indica worked as advertised. I was relaxed. I was what you would call stoned. Somehow, I wasn't too hungry. But I spent an hour deciding what to watch before I gave up and went to bed.`}</p>
    <p>{`As soon as I put the laptop away, I was asleep and I slept like the dead for just the right amount of hours. In the morning, I woke up refreshed and feeling great.`}</p>
    <p>{`Then I went on a 40km run, and the weed had done exactly what I wanted. My muscles were loose and relaxed. I can't remember the last time I felt so un-sore when waking up.`}</p>
    <p>{`Run went well. Indica worked.`}</p>
    <blockquote {...{
      "className": "instagram-media",
      "data-instgrm-captioned": "",
      "data-instgrm-permalink": "https://www.instagram.com/p/Bka1FhQF9S-/?utm_source=ig_embed&utm_campaign=loading",
      "data-instgrm-version": "13",
      "style": {
        "background": "#FFF",
        "border": "0",
        "borderRadius": "3px",
        "boxShadow": "0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)",
        "margin": "1px",
        "maxWidth": "658px",
        "minWidth": "326px",
        "padding": "0",
        "width": "calc(100% - 2px)"
      }
    }}><div parentName="blockquote" {...{
        "style": {
          "padding": "16px"
        }
      }}>{` `}<a parentName="div" {...{
          "href": "https://www.instagram.com/p/Bka1FhQF9S-/?utm_source=ig_embed&utm_campaign=loading",
          "style": {
            "background": "#FFFFFF",
            "lineHeight": "0",
            "padding": "0 0",
            "textAlign": "center",
            "textDecoration": "none",
            "width": "100%"
          },
          "target": "_blank"
        }}>{` `}<div parentName="a" {...{
            "style": {
              "display": "flex",
              "flexDirection": "row",
              "alignItems": "center"
            }
          }}>{` `}<div parentName="div" {...{
              "style": {
                "backgroundColor": "#F4F4F4",
                "borderRadius": "50%",
                "flexGrow": "0",
                "height": "40px",
                "marginRight": "14px",
                "width": "40px"
              }
            }}></div>{` `}<div parentName="div" {...{
              "style": {
                "display": "flex",
                "flexDirection": "column",
                "flexGrow": "1",
                "justifyContent": "center"
              }
            }}>{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "borderRadius": "4px",
                  "flexGrow": "0",
                  "height": "14px",
                  "marginBottom": "6px",
                  "width": "100px"
                }
              }}></div>{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "borderRadius": "4px",
                  "flexGrow": "0",
                  "height": "14px",
                  "width": "60px"
                }
              }}></div></div></div><div parentName="a" {...{
            "style": {
              "padding": "19% 0"
            }
          }}></div>{` `}<div parentName="a" {...{
            "style": {
              "display": "block",
              "height": "50px",
              "margin": "0 auto 12px",
              "width": "50px"
            }
          }}><svg parentName="div" {...{
              "width": "50px",
              "height": "50px",
              "viewBox": "0 0 60 60",
              "version": "1.1",
              "xmlns": "https://www.w3.org/2000/svg",
              "xmlnsXLink": "https://www.w3.org/1999/xlink"
            }}><g parentName="svg" {...{
                "stroke": "none",
                "strokeWidth": "1",
                "fill": "none",
                "fillRule": "evenodd"
              }}><g parentName="g" {...{
                  "transform": "translate(-511.000000, -20.000000)",
                  "fill": "#000000"
                }}><g parentName="g"><path parentName="g" {...{
                      "d": "M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"
                    }}></path></g></g></g></svg></div><div parentName="a" {...{
            "style": {
              "paddingTop": "8px"
            }
          }}>{` `}<div parentName="div" {...{
              "style": {
                "color": "#3897f0",
                "fontFamily": "Arial,sans-serif",
                "fontSize": "14px",
                "fontStyle": "normal",
                "fontWeight": "550",
                "lineHeight": "18px"
              }
            }}>{` View this post on Instagram`}</div></div><div parentName="a" {...{
            "style": {
              "padding": "12.5% 0"
            }
          }}></div>{` `}<div parentName="a" {...{
            "style": {
              "display": "flex",
              "flexDirection": "row",
              "marginBottom": "14px",
              "alignItems": "center"
            }
          }}><div parentName="div">{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "borderRadius": "50%",
                  "height": "12.5px",
                  "width": "12.5px",
                  "transform": "translateX(0px) translateY(7px)"
                }
              }}></div>{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "height": "12.5px",
                  "transform": "rotate(-45deg) translateX(3px) translateY(1px)",
                  "width": "12.5px",
                  "flexGrow": "0",
                  "marginRight": "14px",
                  "marginLeft": "2px"
                }
              }}></div>{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "borderRadius": "50%",
                  "height": "12.5px",
                  "width": "12.5px",
                  "transform": "translateX(9px) translateY(-18px)"
                }
              }}></div></div><div parentName="div" {...{
              "style": {
                "marginLeft": "8px"
              }
            }}>{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "borderRadius": "50%",
                  "flexGrow": "0",
                  "height": "20px",
                  "width": "20px"
                }
              }}></div>{` `}<div parentName="div" {...{
                "style": {
                  "width": "0",
                  "height": "0",
                  "borderTop": "2px solid transparent",
                  "borderLeft": "6px solid #f4f4f4",
                  "borderBottom": "2px solid transparent",
                  "transform": "translateX(16px) translateY(-4px) rotate(30deg)"
                }
              }}></div></div><div parentName="div" {...{
              "style": {
                "marginLeft": "auto"
              }
            }}>{` `}<div parentName="div" {...{
                "style": {
                  "width": "0px",
                  "borderTop": "8px solid #F4F4F4",
                  "borderRight": "8px solid transparent",
                  "transform": "translateY(16px)"
                }
              }}></div>{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "flexGrow": "0",
                  "height": "12px",
                  "width": "16px",
                  "transform": "translateY(-4px)"
                }
              }}></div>{` `}<div parentName="div" {...{
                "style": {
                  "width": "0",
                  "height": "0",
                  "borderTop": "8px solid #F4F4F4",
                  "borderLeft": "8px solid transparent",
                  "transform": "translateY(-4px) translateX(8px)"
                }
              }}></div></div></div>{` `}<div parentName="a" {...{
            "style": {
              "display": "flex",
              "flexDirection": "column",
              "flexGrow": "1",
              "justifyContent": "center",
              "marginBottom": "24px"
            }
          }}>{` `}<div parentName="div" {...{
              "style": {
                "backgroundColor": "#F4F4F4",
                "borderRadius": "4px",
                "flexGrow": "0",
                "height": "14px",
                "marginBottom": "6px",
                "width": "224px"
              }
            }}></div>{` `}<div parentName="div" {...{
              "style": {
                "backgroundColor": "#F4F4F4",
                "borderRadius": "4px",
                "flexGrow": "0",
                "height": "14px",
                "width": "144px"
              }
            }}></div></div></a><p parentName="div" {...{
          "style": {
            "color": "#c9c8cd",
            "fontFamily": "Arial,sans-serif",
            "fontSize": "14px",
            "lineHeight": "17px",
            "marginBottom": "0",
            "marginTop": "8px",
            "overflow": "hidden",
            "padding": "8px 0 7px",
            "textAlign": "center",
            "textOverflow": "ellipsis",
            "whiteSpace": "nowrap"
          }
        }}><a parentName="p" {...{
            "href": "https://www.instagram.com/p/Bka1FhQF9S-/?utm_source=ig_embed&utm_campaign=loading",
            "style": {
              "color": "#c9c8cd",
              "fontFamily": "Arial,sans-serif",
              "fontSize": "14px",
              "fontStyle": "normal",
              "fontWeight": "normal",
              "lineHeight": "17px",
              "textDecoration": "none"
            },
            "target": "_blank"
          }}>{`A post shared by Swizec Teller (@swizec)`}</a></p></div></blockquote>
    <p>{`The second night, on Sunday, I tried a sativa strain.`}</p>
    <p>{`Sativa is meant to give you laser focus. And it did. It gave me so much focus that it was crazy.`}</p>
    <p>{`Anything I looked at, I was pulled into with complete clarity and total focus. Look at a chatroom? Nothing else exists in the world. Look at a productive task? Nothing else exists in the world.`}</p>
    <p>{`It was a strange experience. I don't remember ever being focused like that before. Anything you start doing becomes the only thing in the world and that internal pull to stop doing stuff and go do something else… it just goes away.`}</p>
    <p>{`But if something `}<em parentName="p">{`does`}</em>{` distract you, you're in trouble. You switch focus, and you won't come back on your own.`}</p>
    <p>{`So that was kind of weird. I had intense focus, but it was switchable focus.`}</p>
    <p>{`Like pushing a marble over a series of gravitational wells. Falls into a well. Takes a lot of effort to push over the crest to the next one, then falls right in and stays there.`}</p>
    <p>{`It's hard to explain. You have to try it to get it.`}</p>
    <h2 {...{
      "id": "try-again"
    }}>{`Try again?`}</h2>
    <p>{`I think I will, but with vaping. Looks more civilized. 😇`}</p>
    <p>{`Indica works great before long runs. Helps with how sore I feel.`}</p>
    <p>{`Sativa for focus… needs more testing. Or maybe I need practice with what it feels like to have focused attention.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      